import { TAction } from '@/shared/features/ability/hooks/use-user-ability/use-user-ability.types';

export const PERMISSION_OPERATIONS: TAction[] = [
  'createVersion',
  'create',
  'read',
  'update',
  'delete',
  'linkDevice',
  'linkDocument',
  'linkGateway',
  'linkLicense',
  'linkProject',
  'linkUser',
  'linkVault',
  'linkPipeline',
  'unlinkDevice',
  'unlinkDocument',
  'unlinkGateway',
  'unlinkLicense',
  'unlinkProject',
  'unlinkUser',
  'unlinkVault',
  'unlinkPipeline',
  'lock',
  'unlock',
  'adminUnlock',
  'connect',
  'deploy',
  'backup',
  'snapshot',
  'setPassword',
  'readVariableList',
  'writeVariableList',
  'listVersions',
  'listSecrets',
  'listExecutions',
  'download',
  'triggerExecution',
  'use',
  'unceil',
  'readUser',
  'readUserRole',
  'updateUserRole',
  'createUser',
  'createUserRole',
  'deleteUserRole',
  'deleteUser',
  'updateUser',
];
